import React from "react";
import "./about1.css";
import about1 from "../Imges/About-1.avif";

const First = () => {
  return (
    <div className="hero-container">
      <div className="overlay-content">
        <div className="hero-content">
          {/* Text Section */}
          <div className="hero-text">
            <h2>
              GO&nbsp;AHEAD AND ASK. <br/>WE KNOW YOU'RE CURIOUS. <br/>WHY DIVYAM ADS?
            </h2>
            <p>
              The short answer: we view Divyam Ads as a foundation for growth. It’s an
              organic breeding ground for brilliant marketing ideas. It’s where those ideas
              take root; where they get fed, nourished, and cultivated into masterpieces.
            </p>
            <p>
              Divyam Ads having <strong>EXPERIENCE OF MORE THAN A DECADE</strong> has created
              and crafted successful turnarounds for more than 500 business entities and
              taken them to the next level.
            </p>
          </div>

          {/* Image Section */}
          <div className="hero-image">
            <img src={about1} alt="Creative Workspace" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default First;
